import { STUDENT_CERTIFICATES } from '../../api/endpoints';
import request from '../../api/request';
import { CertificateType, MyCertificate, ReportType } from './types';

/**
 * Pide la lista de reportes disponibles para descargar
 * @returns
 */

export function getAllCertificates(studyPlanEnrollmentId: number) {
  const url = STUDENT_CERTIFICATES.GET_ALL;
  return request<CertificateType[]>(url, {
    params: {
      studyPlanEnrollmentId,
    },
  });
}

/**
 * Descarga el archivo de reporte del url especificado
 * @param reportType El trozo final del endpoint que identifica de donde se decarga el documnento
 * @returns
 */
export const downloadCertificate = (
  studyPlanEnrollmentId: string | number,
  reportType: ReportType,
) => {
  const url = STUDENT_CERTIFICATES.DOWNLOAD_BY_URL(
    studyPlanEnrollmentId,
    reportType,
  );
  return request(url, {
    method: 'POST',
    data: {},
  });
};

/**
 * Genera un certificado con campos dinámicos
 * @param studyPlanEnrollmentId El ID de la inscripción del estudiante
 * @param reportType El tipo de certificado a generar
 * @param customFields Los campos personalizados del formulario dinámico
 * @returns
 */
export const generateCertificateWithCustomFields = (
  studyPlanEnrollmentId: string | number,
  reportType: ReportType,
  customFields: Record<string, any>,
) => {
  const url = STUDENT_CERTIFICATES.DOWNLOAD_BY_URL(
    studyPlanEnrollmentId,
    reportType,
  );
  return request(url, {
    method: 'POST',
    data: {
      customFields,
    },
  });
};

export const getIcebergConfig = () => {
  return request<{ enabled: boolean }>(
    STUDENT_CERTIFICATES.PAYMENT_ICEBERG_CONFIG,
  );
};

export const getMyCertificates = () => {
  return request<MyCertificate[]>(STUDENT_CERTIFICATES.PAYMENT_MY_CERTIFICATES);
};

export const createGatewayPayment = (certificateId: string) => {
  return request<{ url: string }>(
    STUDENT_CERTIFICATES.PAYMENT_CREATE(certificateId),
    { method: 'POST' },
  );
};

export const createIcebergPayment = (certificateId: string) => {
  return request<{ status: string; message: string; certificateId: string }>(
    STUDENT_CERTIFICATES.PAYMENT_ICEBERG_CREATE(certificateId),
    { method: 'POST' },
  );
};

export const getIcebergPaymentStatus = (certificateId: string) => {
  return request<{
    status: string;
    certificateId: string;
    paymentStatus: string;
  }>(STUDENT_CERTIFICATES.PAYMENT_ICEBERG_STATUS(certificateId));
};

export const downloadPaidCertificate = (certificateId: string) => {
  return request<{ url: string }>(
    STUDENT_CERTIFICATES.PAYMENT_DOWNLOAD(certificateId),
  );
};

export const getCertificatePaymentStatus = (certificateId: string) => {
  return request<{
    certificateId: string;
    paymentStatus: string;
    paymentMethod: string | null;
    paidAt: string | null;
    certificateType: {
      name: string;
      paymentRequired: boolean;
      paymentAmount: string;
    } | null;
  }>(STUDENT_CERTIFICATES.PAYMENT_STATUS(certificateId));
};
